import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type SettingsState = {
  volume: number;
  isMuted: boolean;
  /** When true, attempt autoplay on channel select. */
  autoplay: boolean;
  playbackRate: number;
  setVolume: (volume: number) => void;
  toggleMute: () => void;
  setMuted: (muted: boolean) => void;
  setAutoplay: (autoplay: boolean) => void;
  setPlaybackRate: (rate: number) => void;
};

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      volume: 1,
      isMuted: false,
      autoplay: true,
      playbackRate: 1,

      setVolume: (volume) => set({ volume: Math.max(0, Math.min(1, volume)) }),

      toggleMute: () => set((s) => ({ isMuted: !s.isMuted })),

      setMuted: (isMuted) => set({ isMuted }),

      setAutoplay: (autoplay) => set({ autoplay }),

      setPlaybackRate: (playbackRate) => set({ playbackRate }),
    }),
    {
      name: 'streampitch:settings:v1',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
